/**
 * Always renders an `<hr>`, a block-level element that holds margin, padding,
 * width and border on itself, so a wrapper div would only add a redundant
 * element. No configuration changes that.
 */
export const resolveNoContainer = (): boolean => false;
